import { get } from 'lodash'

const defaults = {
  modal: {
    __typename: 'Modal',
    open: false,
    shouldDismiss: false,
    loading: false,
    content: {
      __typename: 'ModalContent',
      type: '',
      selectType: '',
      heading: '',
      body: '',
      items: [],
      imageSource: '',
      zeroStateText: '',
      data: {
        __typename: 'ModalData',
        organizationId: '',
        compositionId: '',
        sectionId: '',
        fromConfirm: false,
        sectionContent: '',
        isProcessing: ''
      }
    }
  }
}

const resolvers = {
  Mutation: {
    modal: (_, { modal }, { cache }) => {
      let items = get(modal, 'content.items', [])
      items = items.map(i => ({
        __typename: 'ModalItem',
        id: i.id,
        name: i.name,
        emrMedicationName: i.emrMedicationName || '',
        medicationStructuredSig: i.medicationStructuredSig || '',
        unstructuredSig: i.unstructuredSig || ''
      }))
      const data = !modal.open
        ? { ...defaults }
        : {
          modal: {
            __typename: 'Modal',
            ...modal,
            items
          }
        }
      cache.writeData({ data })
      return null
    }
  }
}

export default {
  defaults,
  resolvers
}
